/* PRIME HAIR BLACKDEAL 3+1 development copy. Not for publishing before Regios tests.
 * Shopify/Regios must compute every discount. This script only adds/removes the
 * starter kit in the permitted tiers and validates the actual cart totals.
 */
(function () {
  "use strict";
  var CODE = "BLACKDEAL";
  var TAG = "_ph_blackdeal_gift";
  var BONUS_TAG = "_ph_blackdeal_bonus_system";
  var FLASH = "ph_blackdeal_3test_flash";
  var ACTIVE = "ph_blackdeal_3test_active";
  var running = false;
  var timer = null;

  function cartPath(name) {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + name;
  }
  async function api(name, payload) {
    var opts = { credentials: "same-origin" };
    if (payload !== undefined) {
      opts.method = "POST";
      opts.headers = { "Content-Type": "application/json", "Accept": "application/json" };
      opts.body = JSON.stringify(payload);
    }
    var response = await fetch(cartPath(name), opts);
    var json = await response.json();
    if (!response.ok) throw new Error(json.description || json.message || "Warenkorb konnte nicht aktualisiert werden.");
    return json;
  }
  function fields() { return document.querySelectorAll("[data-ph-blackdeal]"); }
  function currentRoot() { return document.querySelector("[data-ph-blackdeal]"); }
  function setState(message, kind, showFourth) {
    fields().forEach(function (el) {
      var status = el.querySelector("[data-ph-blackdeal-status]");
      var fourth = el.querySelector("[data-ph-blackdeal-add-fourth]");
      if (status) {
        // Only show real errors; hide all BLACKDEAL success/info messages.
        var visibleError = kind === "error" && !!message;
        status.textContent = visibleError ? message : "";
        status.dataset.kind = visibleError ? "error" : "info";
        status.hidden = !visibleError;
      }
      if (fourth) fourth.hidden = !showFourth;
    });
  }
  function busy(v) {
    fields().forEach(function(el) {
      var button = el.querySelector("[data-ph-blackdeal-apply]");
      if (button) button.disabled = v;
    });
  }
  function eligibleIds(root) {
    return new Set((root.dataset.eligibleIds || "").split(",").filter(Boolean));
  }
  function eligibleLines(cart, root) {
    var ids = eligibleIds(root);
    return cart.items.filter(function(item) {
      return ids.has(String(item.product_id)) && !item.selling_plan_allocation;
    });
  }
  function systemCount(cart, root) {
    return eligibleLines(cart, root).reduce(function(n, item) {return n + item.quantity;}, 0);
  }
  function ownedGift(cart, variantId) {
    return cart.items.find(function(item) {
      return String(item.variant_id) === String(variantId) && item.properties && item.properties[TAG] === "1";
    });
  }
  function anyGift(cart, variantId) {
    return cart.items.find(function(item) {return String(item.variant_id) === String(variantId);});
  }
  async function removeOwnedGift(cart, variantId) {
    var line = ownedGift(cart, variantId);
    if (!line) return false;
    await api("cart/change.js", {id: line.key, quantity: 0});
    return true;
  }

  function bonus(cart) {
    return cart.items.find(function(x) {return x.properties && x.properties[BONUS_TAG] === "1";});
  }
  function boughtCount(cart, root) {
    return eligibleLines(cart, root).reduce(function(n,x) {
      return n+(x.properties && x.properties[BONUS_TAG] === "1" ? 0 : x.quantity);
    },0);
  }
  async function addBonus(cart, root) {
    if (bonus(cart)) return false;
    var lines=eligibleLines(cart,root).filter(function(x) {
      return !(x.properties && x.properties[BONUS_TAG] === "1");
    });
    lines.sort(function(a,b) {return Number(a.original_price||0)-Number(b.original_price||0);});
    var item=lines[0];
    if (!item || !Number(item.variant_id)) throw new Error("Kein geeignetes viertes System vorhanden.");
    var props=Object.assign({},item.properties||{});
    delete props[TAG];
    delete props[BONUS_TAG];
    props[BONUS_TAG]="1";
    await api("cart/add.js",{items:[{id:Number(item.variant_id),quantity:1,properties:props}]});
    return true;
  }
  async function removeBonus(cart) {
    var x=bonus(cart);
    if(!x) return false;
    await api("cart/change.js",{id:x.key,quantity:0});
    return true;
  }
  function systemDiscountCents(cart, root) {
    return eligibleLines(cart, root).reduce(function(total, item) {
      return total + Math.max(0, Number(item.original_line_price || 0) - Number(item.final_line_price || 0));
    }, 0);
  }
  function orderDiscountCents(cart) {
    return (cart.cart_level_discount_applications || []).reduce(function(total, item) {
      return total + Number(item.total_allocated_amount || 0);
    }, 0);
  }
  function minEligibleUnitPrice(cart, root) {
    var prices = eligibleLines(cart, root).map(function(item) {
      return Number(item.original_price || Math.round(Number(item.original_line_price || 0) / Math.max(item.quantity,1)));
    });
    return prices.length ? Math.min.apply(null, prices) : 0;
  }
  function verify(cart, root, count, variantId) {
    var kit = anyGift(cart, variantId);
    var kitDiscount = kit ? Number(kit.original_line_price || 0) - Number(kit.final_line_price || 0) : 0;
    var otherDiscount = systemDiscountCents(cart, root) + orderDiscountCents(cart);
    if (count === 3 || count === 0) {
      throw new Error("BLACKDEAL ist bei 3 Haarsystemen nicht gueltig. Bitte ein viertes Haarsystem auswaehlen.");
    }
    if (count === 1 || count === 2) {
      if (!kit || Number(kit.quantity) !== 1 || Number(kit.final_line_price) !== 0) {
        throw new Error("Das kostenlose Starter Kit ist im Warenkorb nicht korrekt rabattiert.");
      }
      var target = count === 2 ? 5000 : 0;
      if (Math.abs(otherDiscount - target) > 2) {
        throw new Error(count === 2
          ? "Es muessen genau 50 Euro Zusatzrabatt sein, ohne weitere Rabattkombination."
          : "Bei einem Haarsystem darf BLACKDEAL keinen zusaetzlichen 50-Euro-Rabatt enthalten.");
      }
    } else {
      if (ownedGift(cart, variantId) || (kit && kitDiscount > 0)) {
        throw new Error("Im 3+1 Deal darf das Starter Kit nicht kostenlos sein.");
      }
      var minPrice = minEligibleUnitPrice(cart, root);
      if (minPrice <= 0 || Math.abs(otherDiscount - minPrice) > 2) {
        throw new Error("Der 3+1 Deal ist noch nicht richtig eingestellt: Nur das guenstigste Haarsystem darf gratis sein, ohne zusaetzliche 50 Euro.");
      }
    }
    return true;
  }
  async function clearDiscount() {
    await api("cart/update.js", {discount: ""});
    sessionStorage.removeItem(ACTIVE);
  }
  async function rollback(variantId, removeGift) {
    try {
      var cart = await api("cart.js");
      if (removeGift) await removeOwnedGift(cart, variantId);
      await removeBonus(await api("cart.js"));
      await clearDiscount();
    } catch (err) {
      setState("Bitte den Warenkorb vor dem Bezahlen kontrollieren: " + err.message, "error");
    }
  }
  async function apply(root) {
    if (running) return;
    var field = root.querySelector(".ph-blackdeal__code");
    var code = (field && field.value || "").trim();
    if (!code) {setState("Bitte einen Rabattcode eingeben.", "error");return;}
    running = true; busy(true);
    var giftVariant = root.dataset.giftVariant;
    try {
      if (code.toUpperCase() !== CODE) {
        await api("cart/update.js", {discount: code});
        sessionStorage.setItem(FLASH,"Rabattcode an Shopify uebergeben. Bitte Gueltigkeit im Checkout pruefen.");
        window.location.reload();
        return;
      }
      var before = await api("cart.js");
      var n = boughtCount(before, root);
      if (!n) throw new Error("BLACKDEAL erfordert mindestens ein berechtigtes Haarsystem.");
      if (!giftVariant) throw new Error("Starter Kit ist noch nicht richtig konfiguriert.");
      setState("BLACKDEAL wird geprueft. Bitte noch nicht zur Kasse gehen.", "info", false);
      if (n === 3) {
        await removeOwnedGift(before, giftVariant);
        await addBonus(await api("cart.js"), root);
      } else if (n <= 2) {
        await removeBonus(before);
        if (!anyGift(await api("cart.js"), giftVariant)) {
          var properties = {};
          properties[TAG] = "1";
          await api("cart/add.js", {items:[{id:Number(giftVariant),quantity:1,properties:properties}]});
        }
      } else {
        await removeOwnedGift(before, giftVariant);
        await removeBonus(await api("cart.js"));
      }
      await api("cart/update.js", {discount:CODE});
      var after = await api("cart.js");
      verify(after, root, n === 3 ? 4 : n, giftVariant);
      if (n === 3 && !bonus(after)) throw new Error("Das 4. Haarsystem fehlt.");
      sessionStorage.setItem(ACTIVE,"1");
      sessionStorage.setItem(FLASH, n === 1
        ? "BLACKDEAL: Starter Kit kostenlos."
        : n === 2
          ? "BLACKDEAL: Starter Kit kostenlos plus 50 Euro Rabatt."
          : "BLACKDEAL 3+1: Viertes System automatisch hinzugefuegt. Ein System gratis, kein Starter Kit, keine weiteren 50 Euro.");
      window.location.reload();
    } catch(err) {
      if (code.toUpperCase() === CODE) {
        await rollback(giftVariant, true);
        sessionStorage.setItem(FLASH, "BLACKDEAL nicht angewendet: " + (err.message || "Rabattpruefung fehlgeschlagen."));
        window.location.reload();
        return;
      }
      setState(err.message || "Rabattpruefung fehlgeschlagen.", "error", false);
    } finally {running=false;busy(false);}
  }
  async function remove(root) {
    if (running) return;
    running=true;busy(true);
    try {
      var cart=await api("cart.js");
      await removeOwnedGift(cart,root.dataset.giftVariant);
      await removeBonus(await api("cart.js"));
      await clearDiscount();
      sessionStorage.setItem(FLASH,"BLACKDEAL und die automatisch hinzugefuegte Gratiszugabe wurden entfernt.");
      window.location.reload();
    } catch(err) {setState(err.message,"error");}
    finally {running=false;busy(false);}
  }
  async function reconcile(cart) {
    if (running || sessionStorage.getItem(ACTIVE) !== "1") return;
    var root=currentRoot();
    if (!root) return;
    var n=boughtCount(cart,root);
    var giftVariant=root.dataset.giftVariant;
    var ownKit=ownedGift(cart,giftVariant);
    var ownFourth=bonus(cart);
    if (!n) {
      running=true;
      try {
        if (ownKit) await removeOwnedGift(cart,giftVariant);
        await removeBonus(await api("cart.js"));
        await clearDiscount();
        sessionStorage.setItem(FLASH,"BLACKDEAL entfernt: Kein berechtigtes Haarsystem mehr vorhanden.");
        window.location.reload();
      } finally {running=false;}
      return;
    }
    var changed=n===3 ? !ownFourth || !!ownKit : n>=4 ? !!ownFourth || !!ownKit : !!ownFourth || !anyGift(cart,giftVariant);
    if (!changed) return;
    running=true;
    try {
      if (n===3) {
        if (ownKit) await removeOwnedGift(cart,giftVariant);
        await addBonus(await api("cart.js"),root);
      } else if (n>=4) {
        if (ownKit) await removeOwnedGift(cart,giftVariant);
        await removeBonus(await api("cart.js"));
      } else {
        await removeBonus(cart);
        if(!anyGift(await api("cart.js"),giftVariant)){
          var properties={};properties[TAG]="1";
          await api("cart/add.js",{items:[{id:Number(giftVariant),quantity:1,properties:properties}]});
        }
      }
      await api("cart/update.js",{discount:CODE});
      var after=await api("cart.js");
      verify(after,root,n===3?4:n,giftVariant);
      if(n===3 && !bonus(after))throw new Error("Viertes System nicht im Warenkorb.");
      sessionStorage.setItem(FLASH,"BLACKDEAL nach Warenkorbaenderung aktualisiert.");
      window.location.reload();
    }catch(err){
      await rollback(giftVariant,true);
      sessionStorage.setItem(FLASH,"BLACKDEAL aus Sicherheitsgruenden entfernt: "+err.message);
      window.location.reload();
    }finally {running=false;}
  }
  function scheduleAudit(cart) {
    if (timer) clearTimeout(timer);
    timer=setTimeout(async function() {
      timer=null;
      try {await reconcile(cart || await api("cart.js"));}
      catch(err) {setState("Warenkorbpruefung fehlgeschlagen: "+err.message,"error");}
    },250);
  }
  document.addEventListener("click",function(e) {
    var applyButton=e.target.closest("[data-ph-blackdeal-apply]");
    if (applyButton) {e.preventDefault();apply(applyButton.closest("[data-ph-blackdeal]"));return;}
    var removeButton=e.target.closest("[data-ph-blackdeal-remove]");
    if (removeButton) {e.preventDefault();remove(removeButton.closest("[data-ph-blackdeal]"));}
  });
  document.addEventListener("keydown",function(e) {
    if(e.key!=="Enter" || !e.target.matches("[data-ph-blackdeal] .ph-blackdeal__code"))return;
    e.preventDefault();apply(e.target.closest("[data-ph-blackdeal]"));
  });
  document.addEventListener("cart:change",function(e) {scheduleAudit(e.detail && e.detail.cart);});
  document.addEventListener("DOMContentLoaded",function() {
    var msg=sessionStorage.getItem(FLASH);
    if (msg) {
      var isFailure = msg.indexOf("BLACKDEAL nicht angewendet:") === 0 ||
        msg.indexOf("BLACKDEAL aus Sicherheitsgruenden entfernt:") === 0;
      if (isFailure) setState(msg, "error");
      sessionStorage.removeItem(FLASH);
    }
    if (sessionStorage.getItem(ACTIVE)==="1") {
      fields().forEach(function(el){var btn=el.querySelector("[data-ph-blackdeal-remove]");if(btn)btn.hidden=false;});
      scheduleAudit();
    }
  });
})();